const decodeToken = (token, stripBearer = false) => {
  const cleanToken = (stripBearer ? token.substr(7) : token).split('.')[1].replace(/-/g, '+').replace(/_/g, '/')
  const str = decodeURIComponent(atob(cleanToken).split('').map((c) => `%${(`00${c.charCodeAt(0).toString(16)}`).slice(-2)}`).join(''))
  return JSON.parse(str)
}

export default decodeToken
